import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

export type IQuotationProductDTO = {
  id: number
  code: string | null
  name: string
  picture: {
    mini?: string
    small?: string
    normal?: string
    large?: string
  }
}

export class QuotationProductDTO {
  id: number
  code: string | null
  name: string
  picture: {
    mini?: string
    small?: string
    normal?: string
    large?: string
  }

  constructor(data: IQuotationProductDTO) {
    this.id = data.id
    this.code = data.code
    this.name = data.name
    this.picture = data.picture
  }
}

const validate = createValidate<IQuotationProductDTO>()

export const parseQuotationProductDTO = (data: unknown) => {
  validateGuard(validate, data, 'quotation product')
  return new QuotationProductDTO(data)
}
